import SearchInput from './searchInput';

const searchClearConfig = {
  name: 'searchClear',
  class: SearchInput,
  querySelector: {
    searchInput: '.search-form__form input.search-form__field',
    searchClear: '.search-form--clear',
  },
};

export default searchClearConfig;
